import * as userRequest from "@/utils/userRequest";

export default async function addDevice(
    data: {
        deviceInfo: {
            hash: string;
            info: {
                operatingSystem: string;
                model: string;
            };
        };
    },
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post(
            "auth/add-device",
            {
                ...data,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ addDevice ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
